import { inject } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/services/http/auth.service';
import { AUTH_ROUTES } from '../constants/auth.constants';
import { RouteUtils } from '../utils/route.utils';

export const AuthGuard = (state: RouterStateSnapshot): Observable<boolean> => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // CRITICAL: Allow password reset routes to pass through without authentication
    if (RouteUtils.isPasswordResetRoute(state)) {
        return of(true);
    }

    if (authService.isLoggedIn()) {
        return of(true);
    }

    // Clear all auth data before redirecting to login
    // This ensures a fresh login flow when user needs to authenticate
    authService.clearAllAuthData();

    // Always redirect to auth routes - let universalLoginGuard handle login type
    return from(router.navigate([AUTH_ROUTES.SIGNIN])).pipe(
        map(() => false)
    );
};